export var FVErrorCode;
(function (FVErrorCode) {
    /**
     * Failure to fetch preview data API
     */
    FVErrorCode["PreviewsDataApiFailure"] = "previews_data_api_failure";
    /**
     * When the payload comes back in unexpected shape
     */
    FVErrorCode["MalformedPreviewsDataApiResponse"] = "malformed_previews_data_api_response";
    /**
     * Failure to fetch riviera data
     */
    FVErrorCode["RivieraDataFetchFailure"] = "riviera_data_fetch_failure";
    /**
     * When the riviera payload comes back in unexpected shape
     */
    FVErrorCode["MalformedRivieraData"] = "malformed_riviera_data";
    /**
     * File is too large
     */
    FVErrorCode["FileTooLarge"] = "file_too_large";
    /**
     * We don't support this preview type
     */
    FVErrorCode["UnsupportedPreviewType"] = "unsupported_preview_type";
    /**
     * This file has no extension
     */
    FVErrorCode["NoExtension"] = "no_extension";
    /**
     * This file is password-protected
     */
    FVErrorCode["PasswordProtected"] = "password_protected";
    /**
     * File is encrypted
     */
    FVErrorCode["FileEncrypted"] = "file_encrypted";
    /**
     * File's still being uploaded
     */
    FVErrorCode["FileUploading"] = "file_uploading";
    /**
     * Catch-alls
     */
    FVErrorCode["Unknown"] = "unknown";
    /**
     * File's been switched during bootstrapping
     * so we're no longer doing anything
     */
    FVErrorCode["FileSwitched"] = "file_switched";
    /**
     * The FileInfo supplied was missing necessary identifiers (url/file_id/revision_key)
     */
    FVErrorCode["InvalidFileInfo"] = "invalid_file_info";
    /**
     * When logging session has invalid data
     */
    FVErrorCode["InvalidLoggingSession"] = "invalid_logging_session";
    /**
     * Shown when the user does not have an internet connection (determined by platform)
     */
    FVErrorCode["UserOffline"] = "user_offline";
    /**
     * When a content metadata field (as defined by api_v2/datatypes/previews)
     * is needed and not present (e.g. when loading preview metadata during initialization)
     */
    FVErrorCode["MissingContentMetadata"] = "missing_content_metadata";
    /** Error case when we attempted to preview an archive inside an archive */
    FVErrorCode["NestedFiletypeNotSupported"] = "nested_file_type_not_supported";
    /** We don't support nested previews in password protected archive files */
    FVErrorCode["PasswordProtectedArchivesNotSupported"] = "password_protected_archives_not_supported";
    /** Set intially when no file is provided to File Viewer */
    FVErrorCode["FileNotProvided"] = "file_not_provided";
    /** Specific error page shown for Microsoft Office files that are password protected */
    FVErrorCode["OfficeFilePasswordProtected"] = "office_file_password_protected";
})(FVErrorCode || (FVErrorCode = {}));
export var ErrorLifecycle;
(function (ErrorLifecycle) {
    ErrorLifecycle["Support"] = "support";
    ErrorLifecycle["Download"] = "download";
    ErrorLifecycle["Render"] = "render";
    ErrorLifecycle["Unknown"] = "unkown";
})(ErrorLifecycle || (ErrorLifecycle = {}));
export class FVError extends Error {
    constructor(type, lifecycle, msg) {
        super(msg);
        // This is needed to make 'e instanceof FVError' work
        Object.setPrototypeOf(this, FVError.prototype);
        this.type = type;
        this.lifecycle = lifecycle;
    }
}
//# sourceMappingURL=errors.preenvesnextjs.map
